$(document).ready(function() {
  enableSubmitButtons();
})

window.addEventListener('load', function() {
  window.forms = $('form').not('.wcs-no-validate');
  if (wcs_config.pageName !== 'ClickToChat' && wcs_config.pageName !== 'ClickToCall') {
    autoSuggestionEmail('input#email1');
  }
  validateForms(forms);
  onFocusCheckoutValidation();
  validateEmail();
  enableDisableConfirmPassword();
  onLoadValidation();
  initPasswordDisplay();
  var $countryValue = $("#country_value");
  var $wcsChangePassword = $("#wcs_change_password");
  var $paymentModeForm = $('#payment_mode_form');

  if ("US" === $countryValue.val() && $('#WC_State_DropDown-bill').find('option').length <= 1) {
    $('#stateDiv').attr('style','display:none');
  }
  $('#expire_monthErrMsg').find('.wcs-error-indicator').attr('style','left:112px !important');

  $wcsChangePassword.find('input[name="logonPassword"]').off('blur').blur(function() {
    $wcsChangePassword.find('input[name="logonPasswordVerify"]').attr('pattern', $(this).val());
  });

  $paymentModeForm.find(".pin_1").on('change keyup paste', function() {
    var GCPinCodeEl = $paymentModeForm.find(".pin_1");
    if ($(GCPinCodeEl).attr('maxlength') == $(GCPinCodeEl).val().length) {
      hide_error($(this));
    }
  });
  $paymentModeForm.find(".giftcard_pin_number").on('change keyup paste', function() {
    var GCNumberEl = $paymentModeForm.find(".giftcard_pin_number");
    if ($(GCNumberEl).attr('maxlength') == $(GCNumberEl).val().length) {
      hide_error($(this));
    }
  });
  $("#part-1, #part-2, #part-3").focusout(function () {
    const $target = $(this);
    const $changedInput = $target.closest('.jp-phone-container');

    const currentId = $target.attr('id');
    const part1 = $changedInput.find('#part-1');
    const part2 = $changedInput.find('#part-2');
    const part3 = $changedInput.find('#part-3');
    const regExp = (/^\d{1,6}$/);

    const part1Valid = currentId === 'part-1' || !part1.hasClass('ui-state-error');
    const part2Valid = currentId === 'part-2' || !part2.hasClass('ui-state-error');
    const part3Valid = currentId === 'part-3' || !part3.hasClass('ui-state-error');
    const isPhonePartsValid = part1Valid && part2Valid && part3Valid;

    if (regExp.test($target.val()) && isPhonePartsValid) {
      $changedInput.removeClass('phone-invalid');
    } else {
      $changedInput.addClass('phone-invalid');
    }
  });
  $('#delivery_information_form_add').find('input.required').on('focusout', function() {
    if ($(this).hasClass('ui-state-valid')) {
      $(this).closest('.rb-fieldrow').addClass('rb-validrow');
    } else {
      $(this).closest('.rb-fieldrow').removeClass('rb-validrow');
    }});
  $(".redeemBtn").off("click").on("click", function() {
    $('#orderSummary').find('.gift_card_form input').off('change keyup paste blur').on('change keyup paste blur', function(e) {
      var pattern = $(e.currentTarget);
      var pattRegX = new RegExp(pattern.attr("pattern"));
      var testVal = pattRegX.test(pattern.val());
      if (testVal) {
        hide_error(pattern)
      } else {
        show_error(pattern);
      }
    });
  });

  verifyCardOnPageLoad();

  //Limit Card Verification CVN
  function setCvnLimit(limitNumber, $element) {
    $element.attr('minlength', limitNumber).attr('maxlength', limitNumber);
    $element.attr('pattern', '\\d{'+ limitNumber +'}');
  }

  var $cardVerificationNumber = $("#WC_PaymentInfoForm_cardVerificationNumber_1");
  setCvnLimit(3, $cardVerificationNumber);
  $paymentModeForm.find("#WC_PaymentInfoForm_creditCardNumber_1").on('change keyup paste', function() {
    var $this = $(this);
    $cardVerificationNumber.val("");
    if ($this.hasClass('unknown') || $this.hasClass('mastercard') || $this.hasClass('visa') || $this.hasClass('discover')) {
      setCvnLimit(3, $cardVerificationNumber);
    } else if ($this.hasClass('amex')) {
      setCvnLimit(4, $cardVerificationNumber);
    }
    if($('#WC_PaymentInfoForm_creditCardNumber_1').val() != ''){
      $('#WC_PaymentInfoForm_creditCardNumber_1').siblings('.card').css('display', 'block');
      $('#WC_PaymentInfoForm_creditCardNumber_1').css('padding','16px 16px 16px 80px');

    } else {
      $('#WC_PaymentInfoForm_creditCardNumber_1').siblings('.card').css('display', 'none');
      $('#WC_PaymentInfoForm_creditCardNumber_1').css('padding','16px 16px 16px 16px');

    }
  });

  var $expMonth = $('#WC_PaymentInfoForm_expireMonth_1');
  var $expYear = $('#WC_PaymentInfoForm_expireYear_1');
  $("#WC_PaymentInfoForm_expireYear_1, #WC_PaymentInfoForm_expireMonth_1").change(function(event) {
    event.preventDefault();

    if ($expMonth.val() !== "" && $expYear.val() !== "") {
      hide_Expire_error($(this));
    } else {
      if ($expMonth.val() !== "") {
        $expMonth.addClass("ui-state-valid").removeClass("ui-state-error");
      } else if ($expYear.val() !== "") {
        $expYear.addClass("ui-state-valid").removeClass("ui-state-error");
      }
    }
    return false;
  });
  //klarna
  $("#birthDay, #birthMonth, #birthYear").off("change").on("change", function(event) {
    event.preventDefault();
    var $bDay = $('#birthDay');
    var $bMonth = $('#birthMonth');
    var $bYear = $('#birthYear');

    if ($bDay.val() !== "" && $bMonth.val() !== "" && $bYear.val() !== "") {
      hide_Expire_error($(this));
    } else {
      if ($bDay.val() !== "") {
        $bDay.addClass("ui-state-valid").removeClass("ui-state-error");
      }
      if ($bMonth.val() !== "") {
        $bMonth.addClass("ui-state-valid").removeClass("ui-state-error");
      }
      if ($bYear.val() !== "") {
        $bYear.addClass("ui-state-valid").removeClass("ui-state-error");
      }
    }
    return false;
  }).change();

  //RB-7984
  initCheckboxValidation();

  $(".wcs-default-dropdown").on('click keyup',function(event) {
    event.preventDefault();
    return false;
  });

  //rb-9516
  $('.wcs-details-3-dropDown select').on('change', function(event) {
    var day = $('#wrapper4val').val();
    var month = $('#wrapper5val').val();
    var year = $('#wrapper6val').val();
    var ageLimit = $(this).parents('form').find('input[name="dateOfBirth"]').data('age-limit');
    var age = calculateAgeUsingDate(month,day,year);

    var cutOffAge = ageLimit || 18;
    var $errorMessage = $('.wcs-dob-validate').find('.wcs-error-message');
    $("#wcs-dob-subscribe-error").removeClass("wcs-show").hide();
    if (!age || age < cutOffAge) {
      var $emailSignUp = $('#emailSignUp');
      $errorMessage.addClass('wcs-show');
      if ($emailSignUp.is(':checked')) {
        $emailSignUp.removeAttr('checked').parent().removeClass('wcs-c-on');
      }
    } else {
      $errorMessage.removeClass('wcs-show');
    }
  });
  //end ofrb-9516
  /*
   * Provide the pattern for the zipcode based on country i.e. US
   * or Canada
   */
  $(".wcs-en_CA #delivery_information_form,.wcs-fr_CA #delivery_information_form,.wcs-en_CA #payment_mode_form,.wcs-fr_CA #payment_mode_form").submit(function () {
    return zipCodeCAValidation();
  });

  if ($countryValue.length) {
    zipcode_pattern($('#zip_code'), $countryValue.val());
  }

  // restrict space input
  $('.restrictSpace').unbind('keydown').keydown(function (e) {
    if (e.keyCode === 32) {
      return false;
    }
  });

  // To disable paste and copy in delivery address page for giftcard items
  $('#wcs_userEmail, #wcs_userEmail_confirm, #password, #confirm_password, #wcs_change_email_address .wcs-retype-password-validate, #wcs_change_password .wcs-retype-password-validate').unbind('paste copy', function () {
    return false;
  }).bind('copy paste', function () {
    return false;
  });

  //Fix for RB-17993
  $('#payment_mode_form span.agreeConsent, #user_register_form span.agreeConsent').off('click').on('click', 'a', function (evt) {
    evt.stopPropagation();
  });

  // Format the credit card number on payment page
  var $paymentCreditCardNumber = $('#WC_PaymentInfoForm_creditCardNumber_1');
  if ($paymentCreditCardNumber.length !== 0) {
    $paymentCreditCardNumber.payment('formatCardNumber');
  }
  //RB-7999
  function goBack() {
    window.history.back();
  }
  $(".navBack").on("click", goBack);

  function validateCustomerEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  $('#wcs-customerEmailId, #wcs-customerTelephoneNumber').removeClass('required');

  $('#wcs-customerEmailId, #wcs-customerTelephoneNumber').on('blur',function() {
    var current = $(this);
    if(!current.val()) {
      current.closest('.rb-fieldrow ').removeClass('rb-invalidrow');
    }
  });

  $('.rb-footer .rb-footer__contacts-actions .rb-btn').click(function() {
    var emailAddr = $('.rb-input-wrapper #email');
    if(!emailAddr.parent().hasClass('rb-validrow') && !emailAddr.parent().hasClass('rb-invalidrow')) {
      emailAddr.parent().addClass('rb-invalid');
    }
    else {
      emailAddr.parent().removeClass('rb-invalid');
    }
  });

  var $storeIdentifier = $('#storeIdentifier');
  if ($storeIdentifier.length && $storeIdentifier.val() === "KR") {
    new privacyPolicyCheckbox('#wcs-account-edit-form').init();
    new privacyPolicyCheckbox('#delivery_information_form_KR_add').init();
    new privacyPolicyCheckbox('#user_register_form').init();
  }

  initDOBYearSelect();
  initDOBYearCustomSelect();

  if ($('#popUp').val()) {
    display_Modal_1('wcs-terms-and-condition');
  }
  console.log('card validation init');
});


var loginDOBFunctions = {
  compose: function($selector, year, month, day) {
    var $dobInput = $selector || $('.rb-select-ddmmyyyy-hidden-input');

    if ($dobInput.length > 0 && !!year && !!month && !!day) {
      $dobInput.val(year + '-' + month + '-' + day);
    } else {
      $dobInput.val("");
    }
  },
  validateFields: function($form, onSubmit) {
    var $dateOfBirthInput = $form.find('input[name="dateOfBirth"]');
    var $daySelect = $form.find('[data-attr="wcs-myRegistration-day"]');
    var $monthSelect = $form.find('[data-attr="wcs-myRegistration-month"]');
    var $yearSelect = $form.find('[data-attr="wcs-myRegistration-year"]');

    if ($dateOfBirthInput.size() === 0) {
      return true;
    }

    // values
    var day = parseInt($daySelect.val());
    var month = parseInt($monthSelect.val());
    var year = parseInt($yearSelect.val());
    var ageLimit = $dateOfBirthInput.data('age-limit') || 18;

    var age = null;
    if (month && day && year) {
      age = calculateAgeUsingDate(month, day, year);
    }

    // populate hidden input
    this.compose($dateOfBirthInput, year, month, day);

    // valid data check
    let isDateInvalid = false
    const invalidDateErrorEl = $('.invalid-date-error')
    if (wcs_config.storeId === '25653' && invalidDateErrorEl.length) {
      const monthsWith30 = [4, 6, 9, 11]
      if (day && month && year) {
        if (monthsWith30.includes(month) && day === 31 || month === 2 && day > 29) {
          isDateInvalid = true
        } else if (month === 2 && day === 29 && year % 4 !== 0) {
          isDateInvalid = true
        }
      }
    }
    if (isDateInvalid) {
      invalidDateErrorEl.show()
    } else {
      invalidDateErrorEl.hide()
    }

    // age & date check
    if (age || onSubmit) {
      const isUsa = $('#country').val() === 'USA'
      if (this.validateAge(age, ageLimit) === false || isDateInvalid) {
        $dateOfBirthInput.val('');
        show_error($dateOfBirthInput);
        $('.js-rb-custom-select').removeClass('rb-validrow');
        if(isUsa) {
          $('.invalid-date-error').show();
        }
        return false;
      } else {
        hide_error($dateOfBirthInput);
        $('.js-rb-custom-select').addClass('rb-validrow');
        if(isUsa) {
          $('.invalid-date-error').hide();
        }
        return true;
      }
    }

  },
  validateAge: function(age, cutOffAge) {
    if (!age || age < cutOffAge) {
      return false;
    }
    return true;
  }
}

/**
 * New requirement, Now submitt button are always enabled;
 * Ideally this should be changed at JSP level, but this change came after all the jsp were developed.
 */
window.enableSubmitButtons = function($forms) {
  var $containers = typeof $forms === 'undefined' ? $('body') : $forms;
  var pageVal = $('#page').val();
  var pageVal2 = $('#pageName').val();
  if (pageVal !== 'CreateReturn' && pageVal2 !== 'TrackOrder' && pageVal2 !== "Login and Register" && pageVal2 !== "MyDetails") {
    $containers.find('input[type="submit"]').not('.js-terms_and_conditions').removeAttr("disabled").removeClass("wcs-btn-disable").addClass("blackbtn");
  }
};

validationFields = function ($form) {
  var $$form = $($form);
  var $dateContainer = $$form.find('.date-container');
  var dateContainerClassName = 'date-container--filled';
  var $month = $dateContainer.find('#userMonth');
  var $day = $dateContainer.find('#userDate');
  var $year = $dateContainer.find('#userYear');
  var month = parseInt($month.val(), 10);
  var day = parseInt($day.val(), 10);
  var year = parseInt($year.val(), 10);

  if (day < 10) {
    $day.val('0' + day);
  }

  if (month < 10) {
    $month.val('0' + month);
  }

  if (day && month && year) {
    $dateContainer.addClass(dateContainerClassName);
  }

  var result = $$form.h5Validate('allValid');
  var $selectors = $$form.find('input[type="text"]')
    .add($$form.find('input[type="email"]'))
    .add($$form.find('input[type="tel"]'))
    .add($$form.find('select'))
    .add($$form.find('textarea'));

  if (!result) {
    $selectors.each(function () {
      hide_error($selectors);
    })
  }
}

var globalPageTemplate = $("#pgTemplate").val();

window.onLoadValidation = function () {
  var $deliveryInfoForm = $('#delivery_information_form');
  $deliveryInfoForm.focus();
  if ($deliveryInfoForm.length && globalPageTemplate === "DeliveryPage") {
    validationFields('#delivery_information_form');
  }
}

$("#delivery_information .wcs-label-check:not(.group-input)").off('click').on('click', function () {
  if (globalPageTemplate === "DeliveryPage") {
    var sameAsDeliveryAddress = $("#sameAsDeliveryAddress");
    if (sameAsDeliveryAddress.is(":checked")) {
      setTimeout(function () {
        validationFields('#delivery_information_form');
      }, 500);
    }
  }
});

window.validateForms = function(forms) {
  if ($(forms).attr('id') === "D_X_SignUpOverlay") {
    $('#D_X_SignUpOverlay').find('span.exclamatory').attr('style', 'margin-left: 2px !important');//newsletter-signup
    $('#D_X_SignUpOverlay_SignupForm').attr('style', 'margin-left: 11px !important');
  }

  // set value for onchange h5 validation
  var isCheckout = function () {
    return (globalPageTemplate === "DeliveryPage" || globalPageTemplate === "PaymentPage" ||
      (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && (Number($.cookie("activePanel")) === 1 || Number($.cookie("activePanel")) === 2))) ? false : true;
  }

  // set custom validation for Cyprus zip codes
  if ($("#country_value").val() == "CY") {
    $.ajax({
      url: "FetchCyprusZipcode",
      async: false,
      success: function (result) {
        var response = JSON.parse(result);
        var $zip_code = $('#zip_code');
        $zip_code.removeAttr('pattern').addClass('h5-cyprus-zip');
        if (response.zipcodes) {
          var cyprusZipcodes = Object.keys(response.zipcodes);
          $.h5Validate.validValues('#zip_code', cyprusZipcodes);
        }
        var acceptableZips = $zip_code.data('regex');
        if (acceptableZips) {
          $.h5Validate.addPatterns({
            "cyprus-zip": acceptableZips
          });
        }
      },
      error: function (xhr, status, error) {
        console.error('FetchCyprusZipcode ERROR')
      }
    });
  }
  // end cyprus validation zip code

  forms.h5Validate({
    focusout: isCheckout(),
    activeKeyup: isCheckout(),

    validCallback: function(o) {
      var $el = $(o.element);
      hide_error($el);
      if (globalPageTemplate === "DeliveryPage" || (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && Number($.cookie("activePanel")) === 1)) {
        $el.closest(".wcs-row").addClass('valid-container').removeClass('error-container');
        $el.closest(".rb-fieldrow").addClass('rb-validrow rb-floating').removeClass('rb-invalidrow');
      }

      var formIDVal = $el.closest("form").attr("id");

      if (globalPageTemplate === "DeliveryPage" || globalPageTemplate === "PaymentPage"
        || (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && (Number($.cookie("activePanel")) === 1 || Number($.cookie("activePanel")) === 2))) {
        if (formIDVal !== "user_login_form" && formIDVal !== "forgot_password_form" && formIDVal !== "payment_mode_form" && formIDVal !== "help_contact_us_form") {
          validationSummaryStatus();
        }

        if (!$el.prop('required')) {
          var initOnFocusValidation = new onFocusValidation();
          var $this = $(this);
          if ($this.val() === "") {
            hide_error($this);
            $this.closest(".wcs-row").removeClass('valid-container');
            $this.closest(".rb-fieldrow").removeClass('rb-validrow rb-floating');
          } else if (!$el.prop('required') && $el.attr('id') === 'WC_PaymentInfoForm_fiscal_code') {
            initOnFocusValidation.fiscalCodeValidationIT($this, false);
          } else {
            initOnFocusValidation.simpleValidation($this, false);
          }
        }
      }
    },

    invalidCallback: function(o) {
      var $el = $(o.element);
      show_error($el);
      if (globalPageTemplate === "DeliveryPage" || (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && Number($.cookie("activePanel")) === 1)) {
        $el.closest(".wcs-row").addClass('error-container').removeClass('valid-container');
        $el.closest(".rb-fieldrow").addClass('rb-invalidrow').removeClass('rb-validrow');
      }

      var formIDVal = $el.closest("form").attr("id");

      if (globalPageTemplate === "DeliveryPage" || globalPageTemplate === "PaymentPage"
        || (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && (Number($.cookie("activePanel")) === 1 || Number($.cookie("activePanel")) === 2))) {
        if (formIDVal !== "user_login_form" && formIDVal !== "forgot_password_form" && formIDVal !== "payment_mode_form" && formIDVal !== "help_contact_us_form") {
          validationSummaryStatus();
        }
      }

      if ($("#pageViewName").val() === "SinglePageCheckoutView" && Number($.cookie("activePanel")) === 1) {
        $($el).parents('#deliverySection').prev().nextAll("h3").addClass("ui-state-disabled").removeClass("wcs-complete");
        if (!$el.prop('required')) {
          var initOnFocusValidation = new onFocusValidation();
          var $this = $(this);
          if ($this.val() === "") {
            hide_error($this);
            $this.closest(".wcs-row").removeClass('valid-container');
          } else if (!$el.prop('required') && $el.attr('id') === 'WC_PaymentInfoForm_fiscal_code') {
            initOnFocusValidation.fiscalCodeValidationIT($this, false);
          } else {
            initOnFocusValidation.simpleValidation($this, false);
          }
        }
      }
    },
  });

  onFocusCheckoutValidation = function () {
    var checkoutPages = globalPageTemplate === "DeliveryPage" || globalPageTemplate === "PaymentPage" ||
      (location.pathname.indexOf('SinglePageCheckoutView') !== -1 && (Number($.cookie("activePanel")) === 1 || Number($.cookie("activePanel")) === 2));

    if (checkoutPages) {
      var $creditCardCVC = $('.card-cvc-field');
      var $creditCardField = $('.credit-card-field');
      var $exMonth = $('#exp-month');
      var $exYear = $('#exp-year');
      var $expDateContainer = $('.rb-exp-date');
      var $cardNameField = $('.card-name-field');
      /*GIFT CARD ON Checkout Payment page*/
      var $giftCardNumber = $('#D_CheckoutPayment_GiftCard_Number');
      var $giftCardPin = $('#D_CheckoutPayment_GiftCard_Pin_Code');
      /*GIFT CARD ON Delivery page*/
      var $giftCardMessage = $('#D_DeliveryPage_GiftCard_Message');
      var initOnFocusValidation = new onFocusValidation();

      var $delivery_information_form = $('#delivery_information_form');
      var $billing_address_section = $('#billing_address_section');
      var $pickup_information_form = $('#pickup_information_form');
      var $selectors = $delivery_information_form.find('input[type="text"]').not('#WC_PaymentInfoForm_fiscal_code')
        .add($delivery_information_form.find('input[type="email"]'))
        .add($delivery_information_form.find('input[type="tel"]'))
        .add($delivery_information_form.find('select'))
        .add($delivery_information_form.find('textarea'))
        .add($billing_address_section.find('input[type="tel"]'))
        .add($billing_address_section.find('input[type="text"]')).not('#WC_PaymentInfoForm_fiscal_code')
        .add($billing_address_section.find('input[type="email"]'))
        .add($billing_address_section.find('select'))
        .add($pickup_information_form.find('input[type="text"]')).not('#WC_PaymentInfoForm_fiscal_code')
        .add($pickup_information_form.find('input[type="email"]'))
        .add($pickup_information_form.find('input[type="tel"]'))
        .add($pickup_information_form.find('select'));

      $selectors.on('focusin', function() {
                $(this).closest('.wcs-row, .rb-fieldrow').removeClass('valid-container rb-validrow');
        // $(this).closest(".rb-fieldrow").removeClass('rb-validrow');
      })

      $('#zip_code').on('keyup', function() {
        $(this).add('#city').add('#WC_State_DropDown').closest('.wcs-row, .rb-fieldrow').removeClass("valid-container rb-validrow");
      });

      $selectors.on('focusout', function() {
        var $this = $(this);
        if ($this.val() === "") {
          hide_error($this);
          $this.closest(".wcs-row, .rb-fieldrow").removeClass('valid-container rb-validrow rb-floating');
          // $this.closest(".rb-fieldrow").removeClass('rb-validrow rb-floating');
        } else if ($this.hasClass('ui-state-valid')) {
          $this.closest(".wcs-row, .rb-fieldrow").removeClass('rb-invalidrow').addClass('valid-container rb-validrow rb-floating');
          // $this.closest(".rb-fieldrow").removeClass('rb-invalidrow').addClass('rb-validrow rb-floating');
        } else {
          $this.closest(".rb-fieldrow").addClass('rb-invalidrow rb-floating');
        }
      });

      $creditCardField.on('change focusout', function() {
        initOnFocusValidation.cardValidation($(this), true);
      });

      $expDateContainer.on('focusout', function() {
        initOnFocusValidation.expDateValidation($expDateContainer, $exMonth, $exYear, true);
      });

      $giftCardNumber.on('focusout', function() {
        initOnFocusValidation.simpleValidationShowError($(this));
      });

      $giftCardPin.on('focusout', function() {
        initOnFocusValidation.simpleValidationShowError($(this));
      });

      /*crutch*/
      $giftCardMessage.on('keyup', function(event) { event.stopPropagation(); });
      $giftCardMessage.on('change', function(event, el) {
        if ($(this.closest(".wcs-row")).hasClass('valid-container')) {
          event.stopPropagation();
        }
      });
      $creditCardCVC.on('keyup', function() {
        $(this).val($(this).val().replace(/[^0-9]/,''));
      });

      $creditCardCVC.on('change focusout', function() {
        initOnFocusValidation.cvcValidation($(this), true);
      });

      $cardNameField.on('change focusout', function() {
        initOnFocusValidation.simpleValidation($(this));
      });


      $('#zip_code').on('focusout', function() {
        var country = $('#country_value').val() || $('#country').val();
        if (country === 'MX'){
          var zip=$('#zip_code').val();
          var regex = /^(\d{5})?$/;
          var res = regex.test(zip);
       if(res){
        $('#active_label').show();
       }else{
        $('#active_label').hide();
       }
      }
      });

    }
  }

  initPasswordDisplay = function() {
    $("#user_login_form").length && Rayban.displayPassword('#user_login_form');
    $('#user_register_form').length && Rayban.displayPassword('#user_register_form');
  }

  $("input[type='submit']").off("click.submit").on("click.submit", function(ev) {
    var formid = $('form').attr('id');
    var form = $(this).closest('form');
    var closestFormId = form.attr('id');
    //klarna
    var $consent_box_1_input = $('#consent_box_1_input');
    var $consent_box_2_input = $('#consent_box_2_input');
    if ($('#klarna_radio').is(':checked') && closestFormId !== 'help_contact_us_form') {
      if ($('#klarna_select_1').is(':checked')) {
        $consent_box_1_input.attr('required','required');
        $consent_box_2_input.removeAttr('required','required');
        $consent_box_1_input.next().addClass('checkbox_red');
      } else {
        $consent_box_1_input.removeAttr('required','required');
        $consent_box_1_input.next().removeClass('checkbox_red');
        $consent_box_2_input.attr('required','required');
      }
      if ($('#klarna_select_2').is(':checked')) {
        $consent_box_2_input.attr('required','required');
        $consent_box_2_input.prev().addClass('checkbox_red');
        $consent_box_1_input.removeAttr('required','required');
      } else {
        $consent_box_2_input.removeAttr('required','required');
        $consent_box_2_input.prev().removeClass('checkbox_red');
        $consent_box_1_input.attr('required','required');
      }

    } else {
      $consent_box_2_input.removeAttr('required','required');
      $consent_box_1_input.removeAttr('required','required');
    }

    //klarna
    if ($consent_box_1_input.hasClass('ui-state-error') && closestFormId !== 'help_contact_us_form') {
      $consent_box_1_input.next().addClass('checkbox_red');
    }

    var $idealBanklist = $('#ideal-banklist');
    if ($('#ideal_radio').is(':checked') && $idealBanklist.is(':visible') && closestFormId !== 'help_contact_us_form' && $idealBanklist.val() === 'Select one') {
      $idealBanklist.addClass('ui-state-error').parents('.wcs-row').css('color', '#ec1e24').find('.wcs-error-message').addClass('wcs-show');
      return false;
    }

    var $paymentFormCreditCardNumber = $('#WC_PaymentInfoForm_creditCardNumber_1');
    if ($('#credit_card_radio').is(':checked') && $paymentFormCreditCardNumber.is(':visible') && closestFormId !== 'help_contact_us_form') {
      var cardType = $.trim($.payment.cardType($paymentFormCreditCardNumber.val()));
      var isValid = $.payment.validateCardNumber($paymentFormCreditCardNumber.val(), cardType);

      if (isValid) {
        var analyticAttrVal = "";
        if (cardType.indexOf("amex") !== -1) {
          analyticAttrVal = 'STD CreditCard' + ' ' + cardType;
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="AMEX";
        } else if (cardType.indexOf("discover") !== -1) {
          analyticAttrVal = 'STD CreditCard' + ' ' + cardType;
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="Discover";
        } else if (cardType.indexOf("visa") !== -1) {
          analyticAttrVal = 'STD CreditCard' + ' ' + cardType;
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="VISA";
        } else if (cardType.indexOf("mastercard") !== -1) {
          analyticAttrVal = 'STD CreditCard' + ' ' + cardType;
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="Master Card";
        } else if (cardType.indexOf("dinersclub") !== -1) {
          analyticAttrVal = 'STD Diners';
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="Diners Club";
        } else if (cardType.indexOf("elo") !== -1) {
          analyticAttrVal = 'STD Elo';
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="Elo";
        } else if (cardType.indexOf("hipercard") !== -1) {
          analyticAttrVal = 'STD Hipercard';
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="HiperCard";
        } else if (cardType.indexOf("jcb") !== -1) {
          analyticAttrVal = 'STD JCB';
          $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway',analyticAttrVal);
          cardType="JCB";
        }
        $("#WC_PaymentInfoForm_creditCardType").val(cardType);

        /* Local Storage population for Credit card details form - START */
        clearCreditCardDetailsFromLocalStorage();
        populateCreditCardDetailsToLocalStorage();
        /* Local Storage population for Credit card details form - END */

        window.product && window.product.Products && utagtrackPaymentGateway('CC',cardType, window.product.Products);
      }
    }

    if (closestFormId === "payment_mode_form") {
      if ($('.customer-webid').length > 0 && !checkForterWebId()) {
        return false;
      }

      const isPaymentFormValid = $('#payment_mode_form').h5Validate('allValid');
      const isDeliveryValid = isDeliveryFormValid();

      if (!isDeliveryValid) {
        ev.preventDefault();
      }

      if (isPaymentFormValid && isDeliveryValid) {

        //validate required checkbox
        var $requiredCheckboxLabels = form.find('.wcs-label-check').filter(function() {
          //exclude save credit card checkbox
          return $(this).find('[name="saveSubscription"]').size() === 0;
        });

        $requiredCheckboxLabels.each(function() {
          if (!$(this).hasClass('wcs-c-on')) {
            show_error($requiredCheckboxLabels.find('.wcs-checkbox'));
          }
        });

        $('#checkoutTime').val(new Date().getTime());
        $('input[name="checkoutTime"]').val(new Date().getTime());
        if(wcs_config.isPSD2_Enabled !== 'true' && $('#credit_card_radio').is(':checked')) {
          if (window.callCheckoutSpinnerWithOverlay) {
            ev.preventDefault();
            if(!!document.documentMode){
              $(document.body).off("submit");
            }
            callCheckoutSpinnerWithOverlay(this, '#payment_mode_form');
            form.submit();
          }
        } else {
          addOverlay();
        }
      }
    }

    if ($('#country').val() === 'KR' && closestFormId === "delivery_information_form_KR_add") {
      $('#delivery_information_form_KR_add').h5Validate('allValid');
    }

    //clpCampaign
    if (closestFormId === "clp_campaign") {
      var $clpCampaign = $('#clp_campaign');
      var $email = $('#email');
      $clpCampaign.h5Validate('allValid');
      if ($email.hasClass('ui-state-error')) {
        $email.parent().find('span.wcs-newsletter-error').addClass('wcs-show');
        $email.next().next().attr('style', 'display: block');
        $clpCampaign.find('span.exclamatory').attr('style', 'display: inline !important');
      }
    }

    //callbackForm
    if (closestFormId === "wcs_support_callback_form") {
      if ($('#wcs_support_callback_form').h5Validate('allValid') && !form.find('.wcs-label-check').hasClass('wcs-c-on')) {
        show_error($('.wcs-checkbox'));
      }
    }

    //supportChatForm
    if (closestFormId === "wcs_support_chat_form") {
      if ($('#wcs_support_chat_form').h5Validate('allValid') && !form.find('.wcs-label-check').hasClass('wcs-c-on')) {
        show_error($('.wcs-checkbox'));
      }
    }

    //unified chat form
    if (closestFormId === "unified_chat_form") {
      if ($('#unified_chat_form').h5Validate('allValid') && !form.find('.wcs-label-check').hasClass('wcs-c-on')) {
        show_error($('.wcs-checkbox'));
      }
    }

    //unified call form
    if (closestFormId === "unified_call_form") {
      if ($('#unified_call_form').h5Validate('allValid') && !form.find('.wcs-label-check').hasClass('wcs-c-on')) {
        show_error($('.wcs-checkbox'));
      }
    }

    //hpRedesignCampaign
    if (closestFormId === "wcs-newsletter-footer-signup-form") {
      var $newsletterFooterSignupForm = $('#wcs-newsletter-footer-signup-form');
      var $newsletterFooterSignupFormRightColumn = $newsletterFooterSignupForm.find('.colRight > .wcs-row');
      var $signupEmail = $('#wcs-newsletter-footer-signup-email');
      var $signupEmailParent = $signupEmail.parent();

      $newsletterFooterSignupForm.h5Validate('allValid');
      if ($signupEmail.hasClass('ui-state-error')) {
        $signupEmailParent.find('span.wcs-error-message').addClass('wcs-show');
        $signupEmailParent.find('.exclamatory').attr('style','display: inline !important');
        $newsletterFooterSignupFormRightColumn.addClass('notOverflow');
      } else {
        $newsletterFooterSignupFormRightColumn.removeClass('notOverflow');
      }
    }

    if (closestFormId !== 'help_contact_us_form') {
      monthYearvalidation();
      //klarna
      if ($('#klarna_radio').is(':checked') && $("#country_value").val() != 'US') {
        dbvalidation();
      }
    }

    if (ev.target.id === "next") { window.isSubmit = true; }

    // add if statement recaptcha for check balance form
    if (closestFormId === "check_balance_form") {
      tealium_data2track.push({
        id: 'Click',
        Click_FocusElement: this,
        Tracking_Type: 'hiddenaction',
        data_element_id: 'X_X_GiftCard_CheckBalance',
    });
      if ($('#check_balance_form').h5Validate('allValid')) {
        var response = grecaptcha.getResponse();
        var $errorRecaptcha = $('.error-recaptcha');
        response.length ? $errorRecaptcha.removeClass('wcs-show') : $errorRecaptcha.addClass('wcs-show');
      }
    }
    // end

    if (!giftcard_valid()) {
      var $confirmPassword = $("#confirm_password");

      if (closestFormId === "forgot_password_form" && $(form).parent().hasClass('wcs-user-login')) {
        /*Changing LogonId to Lower Case while Submitting*/
        var $forgotPasswordEmail = $('#forgotPassword_email');
        var logonId = $forgotPasswordEmail.val().toLowerCase();
        $("#ForgotPswdSmallCaseLogonId").val(logonId);
        if ($forgotPasswordEmail.hasClass("ui-state-valid")) {
          $("#forgot_password_div").hide();
          $("#label_email").text($forgotPasswordEmail.val());
          $("#password_sent_success").removeClass("wcs-hide").show();
        }
      }

      if (closestFormId === "user_register_form" || closestFormId === "form_password_reset") {
        if ($("#password").val() !== $confirmPassword.val()) {
          show_error($confirmPassword);
          ev.preventDefault();
        }
      }

      if ($('#storeIdentifier').val() === "KR" && (closestFormId === "user_register_form" || closestFormId === "wcs-account-edit-form")) {
        privacyPolicyCheckbox();
      }

      if (form.attr("name") === "user_register_form" && window.sessionStorage && $("#password").val() === $confirmPassword.val()) {
        sessionStorage.clear();
      }

      if (closestFormId === "user_register_form") {
        var $userRegisterForm = $('#user_register_form');
        $userRegisterForm.find('#agreeConcent').parent().parent().find('span.exclamatory').attr('style', 'float: right; top: -20px;');

        /* Age Validation */
        if (!loginDOBFunctions.validateFields($(form), true)) {
          ev.preventDefault();
        }

        // validation (h5Validate)
        if ($userRegisterForm.h5Validate('allValid') && !form.find('.wcs-label-check').hasClass('wcs-c-on')) {
          show_error($('.wcs-checkbox'));
        }
      }

      if (closestFormId === 'wcs_email_to_friend_form' && !$('.ui-state-error').length && $('#wcs_email_to_friend_form').h5Validate('allValid')) {
        wcs_email_to_friend_form_ajax(ev, form);
      }

      form.find('.date-container').addClass('date-container--filled');

      function dateValidation() {
        var isBirthdayValid = true;
        var isBrazil = $('#country').val() === 'BR';

        if (!isBrazil) {
          return isBirthdayValid;
        }

        var $form = $('#delivery_information_form');
        var $dateContainer = $form.find('.date-container');
        var dateContainerClassName = 'date-container--filled';
        var $month = $dateContainer.find('#userMonth');
        var $day = $dateContainer.find('#userDate');
        var $year = $dateContainer.find('#userYear');
        var $dobFields = $dateContainer.find('#userYear, #userMonth, #userDate');
        var month = parseInt($month.val(), 10);
        var day = parseInt($day.val(), 10);
        var year = parseInt($year.val(), 10);
        var dayValue = $day.val();
        var monthValue = $month.val();
        var date = new Date(year, month - 1, day);
        var currentDate = new Date();

        var reg = /^\d{1}$/;
        var regDay = /0[1-9]|1[0-9]|2[0-9]|3[01]$/;
        var regMonth = /0[1-9]|1[012]$/;
        var regYear = /[0-9]{4}$/;

        if (day < 10 && reg.test(dayValue)) {
          $day.val('0' + day);
        }

        if (month < 10 && reg.test(monthValue)) {
          $month.val('0' + month);
        }

        if (day && month && year) {
          if (date > currentDate) {
            show_error($year);
            show_error($month);
            show_error($day);
            $dobFields.addClass('ui-date-error').closest('.rb-fieldrow').addClass('rb-invalidrow');
            $dateContainer.addClass(dateContainerClassName);
            isBirthdayValid = false;
          } else if (date.getDate() !== day || !regDay.test($day.val())) {
            show_error($day);
            isBirthdayValid = false;
          } else if (date.getMonth() + 1 !== month || !regMonth.test($month.val())) {
            show_error($month);
            isBirthdayValid = false;
          } else if (date.getFullYear() !== year || !regYear.test($year.val())) {
            show_error($year);
            isBirthdayValid = false;
          }
          else {
            hide_error($year);
            hide_error($month);
            hide_error($day);
            $dobFields.removeClass('ui-date-error').closest('.rb-fieldrow').removeClass('rb-invalidrow');
            $dateContainer.addClass(dateContainerClassName);
          }
        }

        return isBirthdayValid;
      }

      // start submit blocking if stella validation fails
      var excludedZipString = $('#stella_excluded_zip').val();
      if ((wcs_config.storeId === '10151' || wcs_config.storeId === '10152') && wcs_config.viewTaskName === 'DeliveryDetailsView' && excludedZipString) {
        const invalidZipcodes = excludedZipString.replaceAll(', ', '|').replace(/[\[\]]+/g,'');
        if (invalidZipcodes !== '') {
          $('#delivery_information_form').h5Validate('allValid');
          let result = stellaZipcodeValidation('submit', invalidZipcodes);
          if (result === 'invalid') {
            return false;
          }
        }
      }
      // end submit blocking if stella validation fails

      if (closestFormId === 'delivery_information_form' && $('#delivery_information_form').h5Validate('allValid')) {

        const country = $('#country').val();
        const isBirthdayValid = dateValidation();
        const $telField = form.find('#tel_number');
        const telValue = $telField.val();

        if (!isBirthdayValid) {
          ev.preventDefault();
          return;
        }

        if (!(/Japan/).test(country)) {
          const formattedTelValue = telValue.replace(/\D/g, '');
        $telField.val(formattedTelValue);
        }
        if (window.callCheckoutSpinnerWithOverlay) {
          ev.preventDefault()
          callCheckoutSpinnerWithOverlay(this, '#delivery_information_form');


          if (wcs_config.storeId === '34153') {
            $('select.regimen-cfd.wcs-hide').remove()
          }

          form.submit()
        }
      }

      /* Changing LogonId to Lower Case while Login */
      if (closestFormId === "user_login_form") {
        var logonEmailInput = $("#loginEmail")
        var logonPasswordInput = $("#wcs_logon_password")
        var logonEmail = logonEmailInput.val();
        var logonPassword = logonPasswordInput.val();
        var logonSmallCase = logonEmail.toLowerCase();
        $("#loginEmailSmallCase").val(logonSmallCase);
        if(!logonEmail || !logonPassword) {
          onVoidLoginOrPassword(ev, logonEmailInput, logonPasswordInput);
        }
      }

      /*call the doctor rox*/
      if (closestFormId === "call-doctor-form") {
        form.find('input:checkbox').each(function() {
          var $this = $(this);
          if ($this.attr('required') && !$this.is(":checked")) {
            $this.parent('label').addClass("wcs-icon-check-error");
          }
        });
      } else {
        form.find('input:checkbox').each(function() {
          var $this = $(this);
          if ($this.attr('required') && !$this.is(":checked")) {
            $this.prev('label').addClass("wcs-icon-check-error");
            ev.preventDefault();
          }
        });
      }
    }

    var $contact_us_form = $('#contact_us_form');
    if (closestFormId === 'contact_us_form' && $contact_us_form.h5Validate('allValid')) {
      $contact_us_form.find('select').attr('id', 'wcs-contact-subject');
      contact_us_form_ajax(ev);
    }

    if (closestFormId === 'help_contact_us_form') {
      var reg = /\S+@\S+\.\S+/;
      var result = reg.test($('#wcs-customerEmailId').val());

      if (result && $('#wcs-customerTelephoneNumber').val().length) {
        $('#wcs-customerEmailId, #wcs-customerTelephoneNumber').removeAttr('required').removeClass('required');
      } else {
          if(!result){
            $('#wcs-customerEmailId').attr('required', true).addClass('required');
          }
          if(!$('#wcs-customerTelephoneNumber').val().length){
            $('#wcs-customerTelephoneNumber').attr('required', true).addClass('required');
          }
      }

      if ($('#help_contact_us_form').h5Validate('allValid') && result && $('#wcs-customerTelephoneNumber').val().length) {
        contact_us_form_ajax(ev);
      } else {
        ev.stopPropagation();
        return false;
      }
    }

    /* Appending timeStamp WIth Nickname while Editing Address */
    if ($(this).attr('id') === 'wcs-editAddr') {
      var stateSelect = $("#stateDisplay").val();
      if (stateSelect === '') {
        $("#stateDisplay").remove();
      }
    }

    /* Appending timeStamp WIth Nickname while Adding Address */
    var isAddAddr = $(this).attr('id') === 'wcs-addAddr';
    var $invalidAddressMsg = $('#invalidAddressMsg');
    if (isAddAddr) {
      $("#nickNameWithTS").val($("#nickName").val());
    }

    if (isAddAddr && !$invalidAddressMsg.hasClass('wcs-show') && 'true' === $('#isAddressValReq').val() && $('#delivery_information_form_add').h5Validate('allValid')) {
      ev.preventDefault();

      var $addressLineOne = $('#address_line_one');
      var $city = $('#city');
      var $zipCode = $('#zip_code');
      var $validDropdown = $(".wcs-default-dropdown.ui-state-valid");
      var $country = $('#country');
      var params = {};

      params.jsonView = 'true';
      params.storeId = $('#storeId').val();
      params.catalogId = $('#catalogId').val();
      params.langId = $('#langId').val();
      params.addressType = 'S';
      params.firstName = $('#userFName_addNewAddress').val();
      params.lastName = $('#userLName_addNewAddress').val();
      params.phone1 = $('#tel_number').val();
      params.address1 = $addressLineOne.val();
      params.address2 = $('#address_line_two').val();
      params.city = $city.val();
      params.country = $country.val();
      params.state = $validDropdown.val();
      params.zipCode = $zipCode.val();

      $.ajax({
        url: "ShippingAddressValidationCmd",
        data: params,
        type: 'POST',
        async: true,
        success: function(result) {
          if (typeof result !== 'object') {
            result = jQuery.parseJSON(result);
          }

          if (result.decision === 'invalidated') {
            $invalidAddressMsg.addClass("wcs-error-message wcs-show").html(result.reasonMessage);
          } else if (result.hasOwnProperty('hasAddressChanged')) {
            result.hasAddressChanged.forEach(function(item) {
              switch(item) {
                case 'address1':
                  $addressLineOne.val(result.address1);
                  break;
                case 'city':
                  $city.val(result.city);
                  break;
                case 'zipCode':
                  $zipCode.val(result.zipCode);
                  break;
                case 'state':
                  $validDropdown.val(result.state);
                  break;
                case 'country':
                  $country.val(result.country);
                  break;
                default:
                  break;
              }
            });
            form.submit();
          } else {
            form.submit();
          }
        }
      });
    }

    /* Contact us remove disabled attribute for submit button */
    var getAttrId = $(this).attr('id');
    if (getAttrId === "wcs_contact_us_submit") {
      var getDropText = $('.wcs-contactus-form .wcs-dropdown-text').val();
      if (getDropText !== "Please select") {
        $("#wcs_contact_us_submit").removeAttr('disabled');
      }
    }

    var $giftWrap = $('#giftWrap');
    if (globalPageTemplate === 'DeliveryPage' && $giftWrap.length > 0 && $giftWrap.is(':checked')) {
      ev.preventDefault();
      gift_wrap_confirm(false, true, false);
    }

    if (globalPageTemplate === 'PayPalExpressCheckoutConfirm' && $giftWrap.length > 0 && $giftWrap.is(':checked')) {
      ev.preventDefault();
      gift_wrap_confirm(false, false, true);
    }

    var $agreeConcent = $('#agreeConcent');
    if (formid === 'delivery_information_form' && $agreeConcent.length && $agreeConcent.is(":checked")) {
      $(".delivery-information-note-red").hide();
    }
  });

  function onVoidLoginOrPassword(event, logonEmailInput, logonPasswordInput) {
    event.preventDefault();

    if(!logonEmailInput.val()) {
      logonEmailInput.parent().removeClass('rb-validrow').addClass('rb-invalidrow');
      logonEmailInput.siblings('.rb-fieldrow__helper--error').show();
    }

    if(!logonPasswordInput.val()) {
      logonPasswordInput.parent().removeClass('rb-validrow').addClass('rb-invalidrow');
      logonPasswordInput.siblings('.rb-fieldrow__helper--error').show();
    }
  };

  // GDPR Age validation
  $('.wcs-dob-select').on('change', function() {
    loginDOBFunctions.validateFields($(this).parents('form'));
  });

  $(".gift_card_form input").off('change keyup paste blur').on('change keyup paste blur', function(e) {
    var pattern = $(e.currentTarget);
    var pattRegX = new RegExp(pattern.attr("pattern"));
    var testVal = pattRegX.test(pattern.val());
    if(testVal) {
      pattern.closest('.rb-fieldrow').removeClass('rb-invalidrow').addClass('rb-validrow');
      hide_error(pattern)
    } else {
      pattern.closest('.rb-fieldrow').removeClass('rb-validrow').addClass('rb-invalidrow');
      show_error(pattern)
    };
  });

  $('input[type="password"]:not(.giftcard_pin_number )').on("blur", function() {
    var $this = $(this);
        if ($this.closest("form").attr("id") !== "user_register_form"
            && $this.closest("form").attr("id") !== "create_account_form"
            && $this.val() !== ""
      && $this.closest("form").attr("id") !== "check_balance_form"
      && $this.attr("id") !== "giftcardpinnumber") {
      var patternValue = /^.*(?=.{7})(?=.*\d)(?=.*[a-zA-Z]).*$/gi ;

      if ($this.val() !== "" && patternValue.test($this.val())) {
        $this.removeClass("ui-state-error").addClass("ui-state-valid");
        hide_error($this);
      } else {
        $this.addClass("ui-state-error").removeClass("ui-state-valid");
        show_error($this);
      }
    }
  });

  // back in stock modal form (desktop)
  $(forms).each(function() {
    var $that = $(this);
    if ($that.attr("id") === "wcs-preorder-email-form") {
      $that.find('.wcs-checkbox').click(function() {
        var $this = $(this);
        var $checkbox = $(this).parent().find('input[type="checkbox"]');
        // it gets the previous state, then !checked===valid
        if ($checkbox.attr('required')) {
          if ($checkbox.is(':checked')) {
            show_error($this);
            $checkbox.addClass('ui-state-error');
          } else {
            hide_error($this);
            $checkbox.removeClass('ui-state-error');
          }
        }
      })
    }
  });
};

var virtualGiftCard = $('#isVirtualGiftCardPage').val();
if (virtualGiftCard === 'Y') {
  function checkEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }
  function compareEmail() {
    var email1 = $('input[name="Remail"]').val(),
      inputConfirm = $('input[name="ConfirmEmail"]'),
      email2 = inputConfirm.val(),
      errorMsg = $('.wcs-error-message-new');
    if (checkEmail(email1) && checkEmail(email2)) {
      var isMatch = email1 === email2;
      if (!isMatch) {
        inputConfirm.addClass('compare-ui-state-error');
        errorMsg.parents('.wcs-row').eq(0).addClass('compare-rb-red-fg');
        errorMsg.addClass('wcs-inline-block');
      } else {
        errorMsg.removeClass('wcs-inline-block');
        inputConfirm.removeClass('compare-ui-state-error');
        errorMsg.parents('.wcs-row').eq(0).removeClass('compare-rb-red-fg');
      }
    }
    if (email1 != email2) {
      inputConfirm.parent().removeClass("rb-validrow").addClass("rb-invalidrow");
    }
  }
}

window.validateEmail = function() {
  $('input[type="email"]').on('focusout', function() {
    if (virtualGiftCard === 'Y') {
      // delivery_information_form
      compareEmail();
    }
  });
};

window.autoSuggestionEmail = function(fieldObj) {
  var $fieldObj = $(fieldObj);
  if ($fieldObj.length) {
    var storeID = $('#storeId').val();
    var url = 'https://' + window.location.host + '/wcs/resources/store/' + storeID + '/XemailDomains/';
    $.ajax({
      url: url,
      type: 'GET',
      async: true,
      success: function(result) {
        var responseJson = result.XemailDomains;
        if (typeof(responseJson) !== 'undefined' && responseJson.length) {
          new Awesomplete(fieldObj, {
            list: responseJson,
            data: function (text, input) {
              return input.slice(0, input.indexOf("@")) + "@" + text;
            },
            filter: Awesomplete.FILTER_STARTSWITH
          });
        }
        if ($fieldObj.closest('.rb-fieldrow').length) {
          var $fieldObjAwesomeContainer = $fieldObj.closest('.awesomplete');
          var detachedFieldElements = $fieldObjAwesomeContainer.siblings().detach();
          $fieldObjAwesomeContainer.append(detachedFieldElements);
          $fieldObj.attr('autocomplete', false);
        }
      }
    });
  }
};

window.callCheckoutSpinnerWithOverlay = function(cObj, formObj) {
  var storeID = $('#storeIdentifier').val();

  if (storeID !== "KR" && storeID !== "CN" && storeID !== "JP") {
    var currentPage = $("#pageNameVal").val() || globalPageTemplate;
    var $submitBtn = $(cObj);

    if ($(formObj).h5Validate('allValid')) {
      if (currentPage === 'DeliveryPage' || currentPage === 'PaymentPage') {
        addOverlay();
      }
    }
  }
}

function addOverlay() {
  var spinnerLoadingText = $('#spinner-loading-text').val() || '';
  var spinnerContainer = '<div class="spinner-container"><i class="fa fa-pulse fa-spinner fa-3x"></i>' +
    '<div class="spinner-loading-text">' + spinnerLoadingText + '</div></div>';

  $('.wcs-fadeout').addClass('wcs-full-overlay-call-checkout').removeClass('wcs-hide').off('click');
  $('.wcs-fadeout.wcs-full-overlay-call-checkout').html(spinnerContainer);
}

$('#create_return_form').submit(function() {
  var rep = 0;
  var ret = 0;
  $(".wcs-reason-rep").each(function () {
    if ($(this).css("display") == "block") {
      rep++;
    }
  });
  $(".wcs-reason-ret").each(function () {
    if ($(this).css("display") == "block") {
      ret++;
    }
  });
  if ($('#store-identifier').val() === 'JP' && $('#scheduled-return-date').val() === '') {
    $('#no-scheduled-date-error').show();
    $('html, body').animate({ scrollTop: 0 }, 'slow');
    return false;
  }
  if (rep > 0 && ret > 0) {
    $("#retrefItemerrorId").show();
    $('html, body').animate({scrollTop: 0}, 'slow');
    return false;
  } else if (window.callReturnsSpinnerWithOverlay) {
    window.callReturnsSpinnerWithOverlay('#return_order_next', '#create_return_form');
  }
});

window.callReturnsSpinnerWithOverlay = function(cObj, formObj) {
  var $submitBtn = $(cObj);

  setTimeout(function() {
    addOverlay();
  }, 1000);
}

var isBagStella = false
if($('#isBagStella').length > 0){
  isBagStella = $('#isBagStella').val()
}

/* Month Year Validation for the Card Expiry date in the Payment Page*/
window.monthYearvalidation = function() {
  var $paymentExpireMonth = $('#WC_PaymentInfoForm_expireMonth_1');
  var $paymentExpireYear = $('#WC_PaymentInfoForm_expireYear_1');
  if ($paymentExpireMonth.val() !== "" && $paymentExpireYear.val() !== "") {
    hide_error($(this));
  } else {
    if ($paymentExpireMonth.val() === "") {
      show_error($paymentExpireMonth);
    } else if ($paymentExpireYear.val() === "") {
      show_error($paymentExpireYear);
    }
  }
};

/* DOB Validation for the Klarna in the Payment Page*/
window.dbvalidation = function() {
  var $bDay = $('#birthDay');
  var $bMonth = $('#birthMonth');
  var $bYear = $('#birthYear');
  var $currentForm = $bYear.closest('form');
  var currentFormId = $currentForm.attr('id');
  if ($bDay.val() !== "" && $bMonth.val() !== "" && $bYear.val() !== "") {
    hide_error($(this));
    $("#klarna-view-message").hide();
    $("#klarna_payment_info .label").removeClass('klarna-error-msg');

  } else {
    if ($bDay.val() === "") {
      show_error($bDay);
      $bDay.addClass("ui-state-error").removeClass("ui-state-valid");
      $("#klarna-view-message").show();
      $("#klarna_payment_info .label").addClass('klarna-error-msg');

    }
    if ($bMonth.val() === "") {
      show_error($bMonth);
      $bMonth.addClass("ui-state-error").removeClass("ui-state-valid");
      $("#klarna-view-message").show();
      $("#klarna_payment_info .label").addClass('klarna-error-msg');

    }
    if ($bYear.val() === "") {
      show_error($bYear);
      $bYear.addClass("ui-state-error").removeClass("ui-state-valid");
      $("#klarna-view-message").show();
      $("#klarna_payment_info .label").addClass('klarna-error-msg');
    }
  }
};


/* function for showing the error of the field. */
window.show_error = function ($fieldObj, stellaEvent) {
  var $currentForm = $fieldObj.closest('form');
  var currentFormId = $currentForm.attr('id');
  var $fieldObjParentsRow = $fieldObj.parents('.wcs-row');
  var $errorMessage = $fieldObjParentsRow.find('.wcs-error-message');
  var fieldObjId = $fieldObj.attr('id');

  if ($fieldObj.closest('.gift_card_form').length) {
    $fieldObj.addClass('ui-state-error');
  }

  if (currentFormId === 'delivery_information_form') {
    $errorMessage.addClass('wcs-inline-block');
    $fieldObj.addClass('ui-state-error');
    if ($('#storeId').val() === '32652' && $fieldObj.is('#zip_code')) {
      if ($fieldObj.val() !== '') {
        if ($('#roe-cc').val() === 'CY' && /(\d{4})/.test($fieldObj.val())) {
          $fieldObj.siblings('span').html($('#roe-cyprus-zip-message').val());
        } else {
          $fieldObj.siblings('span').html($('#roe-zip-valid-message').val());
        }
      } else {
        $fieldObj.siblings('span').html($('#roe-zip-empty-message').val());
      }
    } else if (wcs_config.viewTaskName === 'DeliveryDetailsView' && isBagStella && $fieldObj.is('#zip_code')) {
      if (wcs_config.storeId === '10151') {
        if (/(\d{5})/.test($fieldObj.val()) && stellaEvent) {
          $fieldObj.siblings('span').html($('#stella_excluded_message').val());
        } else {
          $fieldObj.siblings('span').html($('#stella_error_message').val());
        }
      } else if (wcs_config.storeId === '10152') {
        if (/^([a-zA-Z])\d([a-zA-Z])(\s?)\d([a-zA-Z])\d$/.test($fieldObj.val()) && stellaEvent) {
          $fieldObj.siblings('span').html($('#stella_excluded_message').val());
        } else {
          $fieldObj.siblings('span').html($('#stella_error_message').val());
        }
      }
    }
    $fieldObj.closest('.rb-fieldrow')
      .addClass('rb-invalidrow')
      .find('input, select, textarea').removeClass('ui-state-error');
  } else if ($currentForm.hasClass('br_shopping_zipcode_form')) {
    $currentForm.addClass('form-ui-state-error');
    $fieldObj.addClass('ui-state-error');
  } else if (currentFormId === 'eyemed_benefit_registration_form' || currentFormId === 'eyemed_benefit_login_form') {
    $errorMessage.addClass('wcs-show');
    $fieldObj.closest('.wcs-row').addClass('error-row');

    var $ssn = $('#ssn');
    var $zip = $('#zip');
    if (fieldObjId === "zip" && $ssn.val() !== "" && $ssn.hasClass("ui-state-valid")) {
      $zip.removeClass("ui-state-error").closest(".wcs-row").removeClass("error-row").find(".wcs-error-message").removeClass("wcs-show");
    } else if (fieldObjId === "ssn" && $zip.val() !== "" && $zip.hasClass("ui-state-valid")) {
      $ssn.removeClass("ui-state-error").closest(".wcs-row").removeClass("error-row").find(".wcs-error-message").removeClass("wcs-show");
    }
  }

  if (currentFormId === 'D_X_SignUpOverlay') {
    $fieldObj.closest('.wcs-row').addClass("error");
  } else {
    if (!$fieldObjParentsRow.hasClass('klarna-row-dob')) {
      $fieldObjParentsRow.addClass('rb-red-fg');
    }
//    $fieldObjParentsRow.addClass('rb-red-fg');

    var country = $('#country_value').val() || $('#country').val();
    if (!($fieldObj.attr('id') === 'address_line_two' && country === 'MX' && currentFormId === 'delivery_information_form_add')) {
      $fieldObj.parents('.rb-fieldrow').addClass('rb-invalidrow');
    }

    const $jpPhoneField = $currentForm.find('.jp-phone-container');
    const isTargetPhoneNumber = fieldObjId ==='part-1' || fieldObjId ==='part-2' || fieldObjId ==='part-3';

    if ($jpPhoneField && currentFormId === 'delivery_information_form_add' && isTargetPhoneNumber) {
      const $part1 = $jpPhoneField.find('#part-1');
      const $part2 = $jpPhoneField.find('#part-2');
      const $part3 = $jpPhoneField.find('#part-3');
      const regExp = (/^\d{1,6}$/);
      const isPhonePartsValid = regExp.test($part1.val()) && regExp.test($part2.val()) && regExp.test($part3.val());

      if (isPhonePartsValid) {
        $jpPhoneField.removeClass('phone-invalid');
      } else {
        $jpPhoneField.addClass('phone-invalid');
      }
    }
  }

  var formId = $('form').attr('id');
  if (formId === 'delivery_information_form' || formId === 'delivery_information_form_add' || formId === 'utility-search-form' || formId === 'terms_and_conditions') {
    var inputType = $fieldObj.attr('name');
    var country = $('#country_value').val() || $('#country').val();
    if (country === 'MX' && (inputType === 'fax1' || inputType === 'fax1-bill')) {
      var patternValue = new RegExp('^[A-Z0-9]*$');
      var fieldObjValue = $fieldObj.val();
      if (patternValue.test(fieldObjValue) && fieldObjValue.length < 12) {
        $errorMessage.html($fieldObjParentsRow.find('.rfc-length-error-message').val() + '<span class="exclamatory">!</span>');
      } else {
        $errorMessage.html($fieldObjParentsRow.find('.rfc-uppercase-error-message').val() + '<span class="exclamatory">!</span>');
      }
    }
  }

  var $agreeConcent = $('#agreeConcent');
  var $agreeConcentExclamatory = $agreeConcent.parents('.wcs-row').find('span.exclamatory');
  var $agreeConcentCheckbox = $agreeConcent.parents('.wcs-label-check').find('span.wcs-checkbox');
  var $fieldObjParentsForm = $fieldObj.parents('form');
  var fieldObjParentsFormId = $fieldObjParentsForm.attr('id');

  if (formId === "delivery_information_form") {
    $(".wcs-delivery-information .promo-terms .exclamatory").removeAttr("style");
  }

  //callbackForm
  if (formId === "wcs_support_callback_form") {
    $agreeConcentExclamatory.attr('style', 'float: right; top: -63px; left: 68px;');
  }

  //chatform
  if (formId === "wcs_support_chat_form") {
    $agreeConcentExclamatory.attr('style', 'float: right; top: -63px; left: 68px;');
  }

  //unified char form
  if (fieldObjParentsFormId === "unified_chat_form") {
    if (!$("#unified_chat_form").find(".wcs-label-check").hasClass("wcs-c-on")) {
      $agreeConcentCheckbox.addClass('ui-state-error');
    }
  }

  //unified call form
  if (fieldObjParentsFormId === "unified_call_form") {
    if (!$("#unified_call_form").find(".wcs-label-check").hasClass("wcs-c-on")) {
      $agreeConcentCheckbox.addClass('ui-state-error');
    }
  }

  //clp_campaign form
  if (fieldObjParentsFormId === "clp_campaign") {
    var fieldObjType = $fieldObj.attr('type');
    var $newsletterError = $fieldObjParentsRow.find('.wcs-newsletter-error');
    var $exclamatory = $fieldObjParentsRow.find('.span.exclamatory');
    if (fieldObjType === 'email') {
      $newsletterError.attr('style', 'top: 83px; left: 51px;');
      $exclamatory.attr('style', 'top: -25px; left: -25px;');
    }
    if (fieldObjType === 'checkbox') {
      $newsletterError.attr('style', 'top: -32px;');
      $exclamatory.attr('style', 'top: -35px; left:30px;');
    }
  }
  $('#user_register_form').find('#agreeConcent').parent().parent().find('span.exclamatory').attr('style','float:right;top:-20px;');
  $('#overlay-signup-form').find('.wcs-row').find('span.exclamatory').attr('style','margin-left:2px;');
  $('#wcs_support_chat_form').find('.wcs-row').attr('style','width:386px;');
  $('#wcs_support_topic').parents('.wcs-row').find(".exclamatory").attr('style','margin-left:5px;');

  var langIdValue = Number($('#langId').val() || $('input[name="langId"]').val()) === -50;
  if (langIdValue && fieldObjId === 'preorderemailAddress' && fieldObjParentsFormId === 'wcs-preorder-email-form') {
    $errorMessage.attr('style', 'left: -118px');
  }

  if (langIdValue && $('#selectAdd').val() !== 'Please select') {
    var $addressLineTwo = undefined;
    var $mobilePhone = undefined;
    if (fieldObjParentsFormId === 'delivery_information_form') {
      var $editHomeAddressForm = $('#wcs_myDetails_editHomeAddress form');
      $addressLineTwo = $editHomeAddressForm.find('#address_line_two');
      $mobilePhone = $editHomeAddressForm.find('#mobilePhone1');
      $addressLineTwo.parents('.wcs-row').find('.wcs-error-message').attr('style', 'width: 160px;');
      $addressLineTwo.parents('.wcs-four').next().attr('style', 'margin-top: 51px;');
      $mobilePhone.parent().prev().attr('style', 'color: #000 !important;');
      $mobilePhone.parents('.wcs-row').find('.exclamatory').attr('style', 'left: -60px; top: -38px;');
    }
    if (fieldObjParentsFormId === 'delivery_information_form_add') {
      var $addHomeAddressForm = $('#wcs_myDetails_addHomeAddress form');
      $addressLineTwo = $addHomeAddressForm.find('#address_line_two');
      $mobilePhone = $addHomeAddressForm.find('#mobilePhone1');
      $addressLineTwo.parents('.wcs-row').find('.wcs-error-message').attr('style', 'width: 160px;');
      $addressLineTwo.parents('.wcs-four').next().attr('style', 'margin-top: 51px;');
      $mobilePhone.parent().prev().attr('style', 'color: #000 !important;');
      $mobilePhone.parents('.wcs-row').find('.exclamatory').attr('style', 'left: 250px; top: -40px;');
    }
    var fieldObjPraParentId = $fieldObj.parent().parent().parent().parent().attr('id');
    if (fieldObjParentsFormId === 'delivery_information_form' && fieldObjPraParentId === 'addFields') {
      var $addFields = $('#addFields');
      $addressLineTwo = $addFields.find('#address_line_two');
      $mobilePhone = $addFields.find('#mobilePhone1');
      $addressLineTwo.parents('.wcs-row').find('.wcs-error-message').attr('style', 'width: 160px;');
      $addressLineTwo.parents('.wcs-four').next().attr('style', 'margin-top: 51px;');
      $mobilePhone.parent().prev().attr('style', 'color: #000 !important;');
      $mobilePhone.parents('.wcs-row').find('.exclamatory').attr('style', 'left: -285px; top: 60px;');
    }
    if (fieldObjParentsFormId === 'delivery_information_form' && fieldObjPraParentId === 'billing_address_section') {
      var $billingAddressSection = $('#billing_address_section');
      $addressLineTwo = $billingAddressSection.find('#WC_PaymentInfoForm_address2_1');
      $mobilePhone = $billingAddressSection.find('#WC_PaymentInfoForm_mobilePhone1_1');
      $addressLineTwo.parents('.wcs-row').find('.wcs-error-message').attr('style', 'width: 160px;');
      $addressLineTwo.parents('.wcs-four').next().attr('style', 'margin-top: 51px;');
      $mobilePhone.parent().prev().attr('style', 'color: #666 !important;');
      $mobilePhone.parents('.wcs-row').find('.exclamatory').attr('style', 'left: -285px; top: 60px;');
    }
  }

  if (fieldObjParentsFormId === 'help_contact_us_form') {
    if ($fieldObjParentsForm.parent().hasClass('help-us-offline')) {
      // $fieldObj.css('width', '242px');
      $fieldObjParentsRow.find('.wcs-helpus-label').addClass('rb-red-fg');
      $fieldObjParentsRow.css('height', '80px');
    }
  }
};

/* function for hiding the error of field */
window.hide_error = function($fieldObj) {//billing_address_section
  var $fieldObjParentsRow = $fieldObj.parents('.wcs-row, .rb-fieldrow');
  var $fieldObjClosestRow = $fieldObj.closest('.wcs-row, .rb-fieldrow');

  var $fieldObjForm = $fieldObj.closest('form');
  var fieldObjFormId = $fieldObjForm.attr('id');

  if ($fieldObj.closest('.gift_card_form').length) {
    $fieldObj.removeClass("ui-state-error");
  }

  if($("#pageName").val() != "Login and Register" && $("#pageName").val() != "MyDetails" && $("#pageName").val() != "HomePage")
    $fieldObj.removeClass('ui-state-error').closest('.rb-fieldrow').removeClass('rb-invalidrow');

  if ($fieldObjParentsRow.hasClass('group-input') && $fieldObjParentsRow.find('input, textarea, select').hasClass('ui-state-error')) {
    return false;
  } else {
    $fieldObjParentsRow.find('.wcs-error-message').removeClass('wcs-show').removeClass('wcs-inline-block');
    var isChangeEmail = $fieldObjParentsRow.parent().parent('#wcs_change_email_address').length > 0;
    var isChangePassword = $fieldObjParentsRow.parent().parent().parent('#wcs_change_password').length > 0;
    if(!isChangeEmail && !isChangePassword){
      $fieldObjParentsRow.removeAttr('style').removeClass('rb-red-fg rb-invalidrow');
    }
  }

  if (fieldObjFormId === "D_X_SignUpOverlay") {
    $fieldObjClosestRow.removeClass("error");
  }

  if (fieldObjFormId === "D_X_SignUpOverlay" ||
    fieldObjFormId === "wcs-track-order" ||
    fieldObjFormId === "wcs-track-returnOrder" ||
    fieldObjFormId === "check_balance_form" ||
    fieldObjFormId === "user_login_form" ||
    fieldObjFormId === "user_register_form" ||
    fieldObjFormId === "delivery_information_form_add" ||
    fieldObjFormId === "wcs-preorder-email-form") {
    $fieldObjClosestRow.find(".exclamatory").remove();
  }

  var langIdValue = Number($('#langId').val() || $('input[name="langId"]').val()) === -50;
  var selectAddValue = $('#selectAdd').val();
  var fieldObjParentsFormId = $fieldObj.parents('form').attr('id');
  var fieldObjId = $fieldObj.attr('id');

  if (langIdValue && selectAddValue !== "Please select") {
    var $editHomeAddressForm = $('#wcs_myDetails_editHomeAddress form');
    var $editHomeAddressFormAddressLine = $editHomeAddressForm.find('#address_line_two');
    var $addHomeAddressForm = $('#wcs_myDetails_addHomeAddress form');
    var $addHomeAddressFormAddressLine = $addHomeAddressForm.find('#address_line_two');
    var fieldPraParentId = $fieldObj.parent().parent().parent().parent().attr('id');
    var $addFields = $('#addFields');
    var $addFieldsAddressLine = $addFields.find('#address_line_two');
    var $billingAddressSection = $('#billing_address_section');
    var $PaymentInfoFormAddress = $billingAddressSection.find('#WC_PaymentInfoForm_address2_1');

    if (fieldObjParentsFormId === "delivery_information_form") {
      $editHomeAddressFormAddressLine.parents('.wcs-row').find('.wcs-error-message').attr('style','width:160px');
      $editHomeAddressFormAddressLine.parents('.wcs-four').next().removeAttr('style');
      $addHomeAddressFormAddressLine.parents('.wcs-four').parent().find(".exclamatory").hide();
      $editHomeAddressForm.find('#mobilePhone1').parent().prev().attr('style','color:#000 !important');
    }
    if (fieldObjParentsFormId === "delivery_information_form_add") {
      $addHomeAddressFormAddressLine.parents('.wcs-row').find('.wcs-error-message').attr('style','width:160px');
      $addHomeAddressFormAddressLine.parents('.wcs-four').next().removeAttr('style');
      $addHomeAddressFormAddressLine.parents('.wcs-four').parent().find(".exclamatory").hide();
      $addHomeAddressForm.find('#mobilePhone1').parent().prev().attr('style','color:#000 !important');
    }
    if (fieldObjParentsFormId === "delivery_information_form" && fieldPraParentId === "addFields") {
      $addFieldsAddressLine.parents('.wcs-row').find('.wcs-error-message').attr('style','width:160px');
      $addFieldsAddressLine.parents('.wcs-four').next().removeAttr('style');
      $addFields.find('#mobilePhone1').parent().prev().attr('style','color:#000 !important');
    }
    if (fieldObjParentsFormId === "delivery_information_form" && fieldPraParentId === "billing_address_section") {
      $PaymentInfoFormAddress.parents('.wcs-row').find('.wcs-error-message').attr('style','width:160px');
      $PaymentInfoFormAddress.parents('.wcs-four').next().removeAttr('style');
      $billingAddressSection.find('#WC_PaymentInfoForm_mobilePhone1_1').parent().prev().attr('style','color:#000 !important');
    }

    if ($editHomeAddressFormAddressLine.val() === "") {
      show_error($editHomeAddressFormAddressLine);
    }

    if ($addHomeAddressFormAddressLine.val() === "") {
      show_error($addHomeAddressFormAddressLine);
    }

    if (fieldObjId === "address_line_two" && $addFieldsAddressLine.val() === "" && selectAddValue !== "Please select") {
      show_error($addFieldsAddressLine);
    }

    if (fieldObjId === "WC_PaymentInfoForm_address2_1" && $PaymentInfoFormAddress.val() === "" && selectAddValue !== "Please select") {
      show_error($PaymentInfoFormAddress);
    }
  }

  if (fieldObjParentsFormId === "help_contact_us_form") {
    if ($fieldObj.parents("form").parent().hasClass("help-us-offline") && $fieldObj.attr("type") !== "submit") {
      // $fieldObj.css("width","253px");
      $fieldObj.parents(".wcs-row").find(".wcs-helpus-label").addClass('rb-greyLighten2-fg');
      $fieldObj.parents(".wcs-row").css("height","80px");
    }
  }

  if (fieldObjFormId === 'eyemed_benefit_registration_form' || fieldObjFormId === 'eyemed_benefit_login_form') {
    $fieldObjClosestRow.removeClass("error-row");

    if (fieldObjId === "zip" && $fieldObj.val() !== "") {
      removeError($("#ssn"));
    } else if (fieldObjId === "ssn" && $fieldObj.val() !== "") {
      removeError($("#zip"));
    }

    if (fieldObjId === "day" || fieldObjId === "month" || fieldObjId === "year") {
      var $eyemedDob = $(".eyemed-dob");
      if ($eyemedDob.find("select.ui-state-error").length) {
        $eyemedDob.closest(".wcs-row").addClass("error-row").find(".wcs-error-message").addClass("wcs-show");
      }
    }
  }

  if ($fieldObjForm.hasClass('br_shopping_zipcode_form')) {
    $fieldObjForm.removeClass('form-ui-state-error');
    $fieldObj.removeClass("ui-state-error");
  }

  function removeError($element) {
    $element.removeAttr("required").removeClass("ui-state-error")
      .closest(".wcs-row, .rb-fieldrow").removeClass("error-row rb-invalidrow")
      .find(".wcs-error-message").removeClass("wcs-show");
  }
};

window.hide_Expire_error = function(fieldObj) {
  var $fieldObjParentsRow = fieldObj.parents('.wcs-row, .rb-fieldrow');
  $fieldObjParentsRow.find('.wcs-error-message').removeClass('wcs-show');
  $fieldObjParentsRow.removeAttr('style');
  $fieldObjParentsRow.removeClass('rb-red-fg');
  $fieldObjParentsRow.find(".exclamatory").hide();
  fieldObj.addClass("ui-state-valid").removeClass("ui-state-error");
  $fieldObjParentsRow.addClass('rb-validrow').removeClass('rb-invalidrow');
};

window.hide_form_errors = function(formId) {
  var formElements = $('form[id="'+formId+'"]').find('input[type!="hidden"]&&[type!="submit"]');

  formElements.each(function() {
    hide_error($(this));
  });
};

window.reset_form_errors = function(formId) {
  var formElements = $('form[id="'+formId+'"]').find('input, textarea, select')
    .not(':input[type=button], :input[type=submit], :input[type=reset], :input[type=hidden]')
    .each(function() {
      hide_error($(this));
    });

  formElements.each(function() {
    hide_error($(this));
  });
};

window.validationSummaryStatus = function() {
  var errorCount = get_error_count();
  var note_red = $(".wcs-note-red");
  if (errorCount) {

    var number = get_error_number(errorCount);
    var messages = $(".wcs-error-message:visible");
    var note_red_paragraph = note_red.find("p");
    var note_red_number = note_red.find(".number");
    var error_count_value = note_red.find(".error-count-value");
    var langIdValue = Number($('#langId').val() || $('input[name="langId"]').val());

    if (langIdValue === -7) {
      var numberErrorsText = errorCount + ' ' + error_count_value.text().split(' ')[1];

      note_red_number.text(numberErrorsText);
      error_count_value.text(numberErrorsText);
      note_red_paragraph.remove();

      $.each(messages, function () {
        note_red.append("<p>" + $(this).text() + "</p>");
      });
      note_red.parent().removeClass("wcs-hidden");
    } else {
      if (errorCount === 1) {
        note_red_number.text(errorCount + " " + $("input[id='errorTextTranslated']").val() +" ");
        error_count_value.text(errorCount + " " + $("input[id='errorTextTranslated']").val() +" ");
        if ( !(wcs_config.viewTaskName === "DeliveryDetailsView" && $('#user_login_form').length > 0)) {
          note_red_paragraph.remove();
        }

        $.each(messages, function () {
          note_red.append("<p>" + $(this).text() + "</p>");
        });
        note_red.parent().removeClass("wcs-hidden");
      } else {
        note_red_number.text(errorCount + " " + $("input[id='errorsTextTranslated']").val() +" ");
        error_count_value.text(errorCount + " " + $("input[id='errorTextTranslated']").val() +" ");
        note_red_paragraph.remove();

        $.each(messages, function () {
          note_red.append("<p>" + $(this).text() + "</p>");
        });
        note_red.parent().removeClass("wcs-hidden");
        $('.fb-register-form-container').addClass('wcs-hidden');
      }
    }
  } else {
    note_red.parent().addClass("wcs-hidden");

    if (location.pathname.indexOf("PunchoutPaymentCallBack") !== -1 || location.pathname.indexOf("OrderProcess") !== -1) {
      $("#err").closest('.delivery-information-note-red').removeClass("wcs-hidden");
    }
  }
};

/*Above code is modified as edit email in "my details" was not working */

window.initDOBYearSelect = function() {
  /* RB-27005 */
  var $dob_year_select;
  var $register_form_year = $('#user_register_form').find('.wcs-dob-select[name="year"]');
  var $account_edit_form_year = $('#wcs-account-edit-form').find('.wcs-months-dd select[data-attr="wcs-myOrder-year"]');

  $dob_year_select = $register_form_year.size() > 0 ? $register_form_year : $account_edit_form_year;
  if ($dob_year_select.size() > 0) {
    $dob_year_select.each(function() {
      var $this = $(this);
      var year_options = $this.find('option');

      // turn the nodelist into an array and reverse it
      year_options = [].slice.call(year_options).reverse();

      // empty the select
      $this.empty();

      // add each option back
      $.each(year_options, function (i, el) {
        if (!el.value) {
          $this.prepend($(el));
        } else {
          $this.append($(el));
        }
      });
    })
  }
  /* END: RB-27005 */
};

/*Copied from rb.checkoutGiftcardValidation.js as this function is used in login*/
window.giftcard_valid = function() {
  var card_check = $('#piAmount').val();
  return card_check === 0;
};

window.verifyCardOnPageLoad = function() {
  var $creditCardNumber = $('#WC_PaymentInfoForm_creditCardNumber_1');
  if ($('#credit_card_radio').is(':checked') && $creditCardNumber.is(':visible')) {
    var cardType = $.trim($.payment.cardType($creditCardNumber.val()));

    if (cardType !== "") {
      var $cardVerificationNumber = $("#WC_PaymentInfoForm_cardVerificationNumber_1");

      if (cardType.indexOf("amex") !== -1 || cardType.indexOf("discover") !== -1 || cardType.indexOf("visa") !== -1 || cardType.indexOf("mastercard") !== -1) {
        var analyticAttrVal = 'STD CreditCard' + ' ' + cardType;
        $('#payment_confirm_creditCard').attr('data-analytics-Action_Events_CheckoutPaymentGateway', analyticAttrVal);
        $cardVerificationNumber.attr('minlength', 3).attr('maxlength', 3);
      }

      // amex
      if (cardType.indexOf("amex") !== -1) {
        cardType="AMEX";
        $creditCardNumber.addClass('amex');
        $cardVerificationNumber.attr('minlength', 4).attr('maxlength', 4);
      }
      // discover
      if (cardType.indexOf("discover") !== -1) {
        cardType="Discover";
        $creditCardNumber.addClass('discover');
      }
      // visa
      if (cardType.indexOf("visa") !== -1) {
        cardType="VISA";
        $creditCardNumber.addClass('visa');
      }
      // mastercard
      if (cardType.indexOf("mastercard") !== -1) {
        cardType="Master Card";
        $creditCardNumber.addClass('mastercard');
      }

      $("#WC_PaymentInfoForm_creditCardType").val(cardType);

      clearCreditCardDetailsFromLocalStorage();
      populateCreditCardDetailsToLocalStorage();
    }
  }
};
var _validFileExtensions = [".jpg", ".jpeg", ".pdf", ".png"];

window.validateUpload = function(el) {
  var fileName = el.value;
  var fileSize = ($(el)[0].files[0].size / 1024);
  var maxFileSize = (Math.round((fileSize / 1024) * 100) / 100);
  var formParent = el.closest('form');
  var $formParent = $(formParent);
  var $fileSize = $('#fileSize');
  $formParent.find('.wcs-error-message').removeClass('wcs-show');

  if (fileSize / 1024 > 1) {
    if (((fileSize / 1024) / 1024) > 1) {
      fileSize = (Math.round(((fileSize / 1024) / 1024) * 100) / 100);
      $fileSize.html( fileSize + "GB");
    } else {
      fileSize = (Math.round((fileSize / 1024) * 100) / 100);
      $fileSize.html( fileSize + "MB");
    }
  } else {
    fileSize = (Math.round(fileSize * 100) / 100);
    $fileSize.html( fileSize  + "KB");
  }

  if (fileName.length) {
    var extValid = false;
    var $uploadedFileName = $('#wcs-uploaded-file-name');
    var validFileExtensionsLength = _validFileExtensions.length;
    for (var j = 0; j < validFileExtensionsLength; j++) {
      var curExtension = _validFileExtensions[j];
      if (fileName.substr(fileName.length - curExtension.length, curExtension.length).toLowerCase() === curExtension.toLowerCase() && maxFileSize <= 10) {
        extValid = true;
        if (fileName.toLowerCase().indexOf(".jpg") >= 0 || fileName.toLowerCase().indexOf(".png") >= 0  || fileName.toLowerCase().indexOf(".jpeg") >= 0) {
          $uploadedFileName.removeClass('pdf').addClass('image');
        } else {
          $uploadedFileName.removeClass('image').addClass('pdf');
        }
        $formParent.find('input[type=submit]').attr('disabled',false);
        break;
      }
    }
    if (!extValid) {
      $formParent.find('.wcs-error-message').addClass('wcs-show');
      $uploadedFileName.attr('class', 'wcs-columns wcs-four color-000');
      $formParent.find('input[type=submit]').attr('disabled',true);
      return false;
    }
  }
  return true;
};

window.enableDisableConfirmPassword = function() {
  const $confirm_password = $('#user_register_form').find('#confirm_password');
  const $restrictionUppercaseEl = $('#password-restriction .restriction-uppercase');
  const $restrictionLowercaseEl =$('#password-restriction .restriction-lowercase');
  const $restrictionNumberEl = $('#password-restriction .restriction-number');
  const $restrictionLengthEl = $('#password-restriction .restriction-length');
  const $restrictionSymbolEl =$('#password-restriction .restriction-symbol');
  const uppercaseRule = { regExp: /[A-Z]{1}/, ruleDetailsEl: $restrictionUppercaseEl };
  const lowercaseRule = { regExp: /[a-z]{1}/, ruleDetailsEl: $restrictionLowercaseEl };
  const digitRule = { regExp: /\d{1}/, ruleDetailsEl: $restrictionNumberEl };
  const lengthRule = { regExp: /^.{8,20}$/, ruleDetailsEl: $restrictionLengthEl };
  const symbolRule = { regExp: /\W{1}/, ruleDetailsEl: $restrictionSymbolEl };
  const restrictionRules = [uppercaseRule, lowercaseRule, digitRule, lengthRule, symbolRule];

  if ($('#user_register_form').attr('action') !== 'UserRegistrationAddOrderConfirm') {
    $confirm_password.attr('readonly',true);
  }
  // This is valiate the confirm password as the the password text value, also make sure the confirm password is equal to password field.
  $('#password').off("blur").blur(function() {
    const $this = $(this);
    const pwd = $this.val()
    const pwdValid = restrictedPasswordValidation(pwd);
    $('#confirm_password').attr('pattern', pwd);
    if (pwdValid) {
      $this.removeClass("ui-state-error").addClass("ui-state-valid");
      $confirm_password.attr('readonly', false);
      hide_error($this);
    } else {
      $this.addClass("ui-state-error").removeClass("ui-state-valid");
      $confirm_password.attr('readonly', true);
      show_error($this);
    }
  })

  $('#ripass2').focusout(function() {
    const $this = $(this);
    const pwdValid = restrictedPasswordValidation($this.val());
    if (pwdValid) {
      $this.removeClass("ui-state-error").addClass("ui-state-valid");
      $this.closest('.rb-fieldrow').addClass("rb-validrow").removeClass("rb-invalidrow");
      hide_error($this);
    } else {
      $this.addClass("ui-state-error").removeClass("ui-state-valid");
      $this.closest('.rb-fieldrow').addClass("rb-invalidrow").removeClass("rb-validrow");
      show_error($this);
    }
  })

  $('#password, #ripass2').keyup(function () {
    restrictedPasswordValidation($(this).val())
  });

  function restrictedPasswordValidation(pwd){
    let validRulesCount = 0;
    restrictionRules.forEach(rule => {
      if (pwd.match(rule.regExp)) {
        rule.ruleDetailsEl.addClass('rule-valid').removeClass('rule-invalid');
        validRulesCount++;
      } else {
        rule.ruleDetailsEl.removeClass('rule-valid').addClass('rule-invalid');
      }
    });
    return validRulesCount > 4;
  }
};

window.encodeEmail = function(event) {
  if ($('#storeIdentifier').val() === "BR") {
    event.preventDefault();
    var email = $('input[name^="email1"]');
    email.val(encodeURI(email.val()));
    $('form[name^="track_order_form"]').submit();
  }
};

//RB-7984
window.initCheckboxValidation = function($forms) {
  var $containers = typeof $forms === 'undefined' ? $('body') : $forms;

  function clickAgree() {
    if ($("#agreeConcent").is(":checked")) {
      validationSummaryStatus();
    }
  }

  //RB-7984
  $containers.find(".wcs-checkbox").off('click.rbFormValidation').on('click.rbFormValidation', function() {
    var $this = $(this);
    var currentFormId = $this.parents('form').attr('id');
    var $currentFormCheckbox = $this.parent().find('input[type="checkbox"]');

    if (currentFormId === "user_register_form") {
      var $parentsRow = $this.parents('.wcs-row');
      var $errorMessage = $parentsRow.find('.wcs-error-message');
      var $exclamatory = $parentsRow.find('.exclamatory');

      if (!$currentFormCheckbox.is(':checked')) {
        // action will check the input checkbox, so remove errors
        $errorMessage.removeClass('wcs-show');
        $exclamatory.hide();
      } else if ($currentFormCheckbox.hasClass('ui-state-error')) {
        $errorMessage.addClass('wcs-show');
        $exclamatory.show();
      }
      // show error in unchecked & on blur
      $this.off('blur.rbFormValidation').on('blur.rbFormValidation', function() {
        var $real_checkbox = $currentFormCheckbox;

        if (!$real_checkbox.is(':checked')) {
          if ($real_checkbox.hasClass('ui-state-error')) {
            $errorMessage.addClass('wcs-show');
            $exclamatory.show();
          }
        } else {
          $errorMessage.removeClass('wcs-show');
          $exclamatory.hide();
        }
      });
    }

    if (currentFormId !== "user_register_form") {
      setTimeout(clickAgree,1000);
    }

    //rb-9516
    if (currentFormId === "wcs-account-edit-form") {
      var day = $('#wrapper4val').val();
      var month = $('#wrapper5val').val();
      var year = $('#wrapper6val').val();
      var age = calculateAgeUsingDate(month,day,year);
      var cutOffAge =18;
      $("#wcs-dob-error").removeClass("wcs-show").hide();
      var $dobSubscribeError = $('#wcs-dob-subscribe-error');
      if (age < cutOffAge) {
        $dobSubscribeError.addClass("wcs-show").show();
        return false;
      } else {
        $dobSubscribeError.removeClass("wcs-show").hide();
        return true;
      }
    }
    //end of rb-9516
  });
};

function initDOBYearCustomSelect() {
  var $dob_year_custom_select;
  var $register_custom_form_year = $('#user_register_form').find('.year-dropdown ul');
  var $account_custom_edit_form_year = $('#wcs-account-edit-form').find('.year-dropdown ul');

  $dob_year_custom_select = $register_custom_form_year.size() > 0 ? $register_custom_form_year : $account_custom_edit_form_year;

  if ($dob_year_custom_select.size() > 0) {
    $dob_year_custom_select.each(function() {
      var $this = $(this);
      var year_custom_options = $this.find('li');
      year_custom_options = [].slice.call(year_custom_options).reverse();

      $this.empty();

      $.each(year_custom_options, function (i, el) {
        if (!$(el).hasClass('js-year-option')) {
          $this.prepend($(el));
        } else {
          $this.append($(el));
        }
      });
    })
  }
}

function checkForterWebId() {
  var $customerWebid = $('.customer-webid');
  var $errorMessage = $customerWebid.parent('.csr-webId-wrapper').find('.wcs-error-message');
  var webId = $customerWebid.val();
  if (!(webIdFormatCheck(webId)) || !(webIdLuhnCheck(webId))) {
    $errorMessage.addClass('wcs-show').removeClass('wcs-hide');
    return false;
  } else {
    $errorMessage.removeClass('wcs-show').addClass('wcs-hide');
  }
  return true;
}

function webIdFormatCheck(id) {
  return /^\d{9}$/.test(id);
}

function webIdLuhnCheck(id) {
  var nCheck = 0, nDigit = 0, bEven = false;

  for (var n = id.length - 1; n >= 0; n--) {
    var cDigit = id.charAt(n),
      nDigit = parseInt(cDigit, 10);

    if (bEven) {
      if ((nDigit *= 2) > 9) nDigit -= 9;
    }

    nCheck += nDigit;
    bEven = !bEven;
  }
  return (nCheck % 10) == 0;
}

$('.rb-static-page__aside-menu-sub-item a').click(function() {
  $('.rb-static-page__aside-menu-sub-item').removeClass('rb-static-page__aside-menu-sub-item--selected');
  $(this).parent().addClass('rb-static-page__aside-menu-sub-item--selected');
});

$('#wcs_support_chat_submit').click(function(){
  var telCode = $('#tel_code');
  var telNumber = $('#tel_number');
  if (telCode.val() === '' || telNumber.val() === '' ) {
    telCode.addClass('empty-value');
    telNumber.addClass('empty-value');
  }
  else {
    telCode.removeClass('empty-value');
    telNumber.removeClass('empty-value');
  }
});

$(function() {
  $('#password, #ripass2').focus(function () {
    $('#password-restriction').show();
  })
  $('#password, #ripass2').focusout(function () {
    if ($(this).val().length === 0) {
      $('#password-restriction').hide();
    }
  })
});

$('#user_register_form input[type=text]').change(function(){
  this.value = $.trim(this.value);
});

//start stella validation zipcode function
function stellaZipcodeValidation(type, invalidZipcodes) {
  const $zip_code = $('#zip_code');
  let result = new RegExp('^(?!.*(' + invalidZipcodes + '))').test($zip_code.val());
  if (result === false) {
    $zip_code.closest('.rb-fieldrow').removeClass('rb-validrow').addClass('rb-invalidrow');
    show_error($zip_code, true);
    if (type === 'submit') {
      return 'invalid';
    }
  }
}
//end stella validation zipcode function

function isDeliveryFormValid() {
  if ($('#arrange-delivery').is(':checked')) {
    const selectArray = $('.arrange-block select').toArray();

    if (selectArray.some(elem => !elem.value)) {
      selectArray.forEach(elem => {
        if (!elem.value) {
          $(elem).closest('.rb-fieldrow').addClass('rb-invalidrow');
        }
      });
      $('html,body').animate({ scrollTop: $(".rb-invalidrow:first").offset().top}, 'slow');
      return false;
    } else {
      return true;
    }
  }
  return true;
};
